import { DatePipe } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { userInfo } from "node:os";
import { Subscription } from "rxjs";
import { Constants } from "src/app/app.constants";
import { AppService } from "src/app/app.service";
import { StorageService } from "src/app/app.storage.service";
import { AttendanceConstant } from "../attendance.constant";
import { AttendanceService } from "../attendance.service";

@Component({
    selector: 'app-edit-team-attendnace',
    templateUrl: './edit-team-attendnace.component.html',
    styleUrls: ['./edit-team-attendnace.component.css']
})

export class EditTeamAttendnaceComponent{
    constructor(
        private storageService: StorageService,
        private appService: AppService,
        private router: Router,
        private attendanceService: AttendanceService,
        private datePipe: DatePipe
    ){}

    personAttendnaceDetailsList: any[] = [];
    isAllCheck: boolean = false;
    userInfo: any = {};

    attendanceTypeSubscription: Subscription;
    attendanceTypeMap: any = {};
    statusList :any[]= AttendanceConstant.ATTENDANCE_STATUS_LIST;

    async ngOnInit(){
        // this.attendanceTypeSubscription = this.attendanceService.attendanceTypeSubject.subscribe((data)=>{
        //     if(data){
        //         this.attendanceTypeMap = data.map;
        //     }
        //   })
          var obj= {};
          obj['showLeave'] = false;
          obj['showMarkAttendance'] = true;

         this.attendanceService.showLeaveApplicationSubject.next(obj);

        let data1 = await this.appService.getAttendnaceTypeObject().catch(()=>{});
        if(data1){
            this.attendanceTypeMap = data1.map;
        }

        let data = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.EDIT_ATTENDANCE_PERSON);

        this.preProcess(data);
    }

 
    ngOnDestroy(){
        if(this.attendanceTypeSubscription){
          this.attendanceTypeSubscription.unsubscribe()
        }
      }


    navigateToTeamAttendnace(){
        var obj= {};
        obj['showLeave'] = true;
        obj['showMarkAttendance'] = true;

       this.attendanceService.showLeaveApplicationSubject.next(obj);
       
        this.attendanceService.teamAttendanceUserSubject.next(null);
        this.router.navigate(['home/attendance/team-attendance']);
       
    }

    preProcess(data){
        if(data){
            this.userInfo = data.userInfo;
            this.attendanceService.teamAttendanceUserSubject.next(this.userInfo);
            let attendanceObj = data.dayWiseAttendances;
            if(attendanceObj && Object.keys(attendanceObj).length > 0){
                let values: any[] = Object.values(attendanceObj);
                for(let obj of values){
                    obj = this.attendanceService.preProcessAttendnaceData(obj, this.attendanceTypeMap);
                    obj['markAttendnaceDateStr'] = "";
                    if(obj.creationTimestamp){
                        obj['markAttendnaceDateStr'] = this.datePipe.transform(obj.creationTimestamp *1000, 'EEEE, dd MMM, hh:mm a');
                    }
                    obj['approveStatusObj'] = AttendanceConstant.ATTENDANCE_STATUS_LIST[0];
                    if(obj.status){
                        obj['approveStatusObj'] = AttendanceConstant.ATTENDANCE_STATUS_LIST.find((elem) =>{return elem.key == obj.status})
                        if(obj.status && AttendanceConstant.ATTENDANCE_STATUS_MAP[obj.status]){
                            obj['statusStr'] = AttendanceConstant.ATTENDANCE_STATUS_MAP[obj.status].text;
                            obj['statusClass'] = AttendanceConstant.ATTENDANCE_STATUS_MAP[obj.status].colorClass;
                        }
                    }
                }
                this.personAttendnaceDetailsList =  values;
               
            }
        }
    }

    checkAllClick(){
        let bool = false;
        if(this.isAllCheck){
            bool = true;
        }
        for(let obj of this.personAttendnaceDetailsList){
            obj.isChecked = bool;
        }
    }

    onApproveClick(){
        let attendanceApproveList = [];
        for(let obj of this.personAttendnaceDetailsList){
            if(obj.isChecked && obj.mark && obj.approveStatusObj){
                let object = {};
                object['id'] = obj.id;
                // object['status'] = obj.status;
                object['status'] =obj.approveStatusObj.key;
                attendanceApproveList.push(object);
            }
        }
        if(attendanceApproveList && attendanceApproveList.length>0){
            this.attendanceService.saveAttendnaceApproval(attendanceApproveList)
                .subscribe((res: HttpResponse<any>) =>{
                    // console.log(res.body);
                    this.appService.showSuccessPopup("Success", "Status updated Successfully .");
                    this.navigateToTeamAttendnace();
                }, (err)=>{
                    this.appService.showErrorPopup("Error", "Something went wrong.");
                })
        }else{
            this.appService.showErrorPopup("Message", "Please Check atleast one Attendance!");
            return;
        }
    }
    




}